import React from 'react';
import { render } from 'react-dom';

import ImageBlock from '../react/ImageBlock';

export default class ImageBlockRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model } = this.context.dataset;
    if (!model) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(<ImageBlock image={jsonModel} />, this.context);
  }
}
